import { JsonConverter, JsonCustomConvert } from 'json2typescript';
import * as utils from '../core.utils';

@JsonConverter
export class DateOnlyConverter implements JsonCustomConvert<Date> {
	serialize(date: Date): any {
		console.log('DateOnlyConverter.serialize', date);
		if (!date) {
			return null;
		}
		return date.toISOString().split('T')[0];
	}
	deserialize(date: any): Date {
		if (!date) {
			return null;
		}

		return utils.parseDate(date);
	}
}